import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import GISPanel from './GISPanel'

export const TaskDetailGIS: React.FC = () => {
  return (
    <>
      <Grid container spacing={2} justifyContent='center' alignItems='flex-start'>
        <Grid item xs={6}>
          <Typography variant='body2'>
            Once the requisite project data has been provided, the GIS manager should upload a clean
            GIS file, which at the minimum must have at least one column which identifies
            archetype/program information about each building, one column which identifies the
            height of each building, and ideally an additional column which identifies the age of
            the building (or another numerical value which might be used for a secondary level of
            segmentation of the building stock by the energy modeler).
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant='body2'>
            Use the widget below to upload a file; once uploaded you will automatically be directed
            to the Key Fields assignment page to identify which columns from the original file will
            be used to identify the segmentation metadata.
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export const TaskActionGIS: React.FC = () => {
  return <GISPanel />
}
